// Main application wrapper
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CustomThemeProvider } from '../providers/Theme';

interface AppWrapperProps {
  children: React.ReactNode;
}

export default function AppWrapper({ children }: AppWrapperProps) {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <CustomThemeProvider>
        {children}
      </CustomThemeProvider>
    </BrowserRouter>
  );
}

